import type { TooltipState } from './useTooltip'

/** The floating box: value first (bold), then what it belongs to. */
export default function Tooltip({ tip }: { tip: TooltipState }) {
  if (!tip) return null
  return (
    <div className="chart-tooltip" style={{ left: tip.x, top: tip.y }} role="status">
      <strong>{tip.value}</strong>
      <span>{tip.label}</span>
    </div>
  )
}
